import { render, staticRenderFns } from "./TaggedCollectionProjectListModal.vue?vue&type=template&id=98024ff6&"
import script from "./TaggedCollectionProjectListModal.vue?vue&type=script&lang=js&"
export * from "./TaggedCollectionProjectListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98024ff6')) {
      api.createRecord('98024ff6', component.options)
    } else {
      api.reload('98024ff6', component.options)
    }
    module.hot.accept("./TaggedCollectionProjectListModal.vue?vue&type=template&id=98024ff6&", function () {
      api.rerender('98024ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/TaggedCollectionProjectListModal.vue"
export default component.exports